// extracted by mini-css-extract-plugin
module.exports = {"NearByButton":"NearByButton-YdDhj","NearByContainer":"NearByContainer-2kI1S","NearByIcon":"NearByIcon-2L7NB","NearByText":"NearByText-1XNpo"};